import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../Utils/api";
import img from "../../Assets/login-img.png";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await API.post("/admins/admin-login", {
        identifier: email,
        password,
        userType: "admin",
      });

      console.log("Response:", res.data);

      const admin = res?.data?.admin;
      const token = res?.data?.token;

      if (!admin || !token) {
        alert("Invalid response");
        return;
      }

      localStorage.setItem("adminInfo", JSON.stringify(admin));
      localStorage.setItem("token", token);

      navigate("/dashboard");
    } catch (error) {
      console.error("Login error:", error);
      alert(error.response?.data?.message || "Login failed");
    }
  };
  const goToForgotPassword = () => {
    navigate("/forgot-password");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#3A7138] via-[#4f8c4d] to-[#1A3617] px-4">
      <div className="w-full max-w-6xl bg-white rounded-3xl shadow-2xl overflow-hidden grid lg:grid-cols-2">
        {/* Left Section */}
        <div className="p-8 sm:p-12 lg:p-16">
          <div className="text-3xl sm:text-4xl font-serif text-[#1A3617] mb-8">
            Kalinga-Bio Admin
          </div>

          <h2 className="text-3xl sm:text-4xl font-serif text-[#1A3617] mb-10">
            Log in
          </h2>

          <form onSubmit={handleSubmit}>
            {/* Email */}
            <div>
              <label className="text-sm font-semibold text-gray-600">
                Email Address
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full mt-2 px-4 py-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#3A7138] transition"
              />
            </div>

            {/* Password */}
            <div className="mt-6">
              <div className="flex justify-between items-center">
                <label className="text-sm font-semibold text-gray-600">
                  Password
                </label>
                <button
                  type="button"
                  onClick={goToForgotPassword}
                  className="text-xs font-semibold text-[#3A7138] hover:underline"
                >
                  Forgot Password?
                </button>
              </div>

              <div className="relative mt-2">
                <input
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#3A7138] transition pr-12"
                />

                {/* Eye Icon */}
                <span
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer text-gray-500"
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>
            </div>
            {/* Button */}
            <button
              type="submit"
              className="w-full mt-8 py-3 rounded-xl text-white font-semibold 
              bg-gradient-to-r from-[#3A7138] to-[#1A3617] 
              hover:opacity-90 transition shadow-lg"
            >
              Log In
            </button>
          </form>

          {/* <div className="mt-8 text-sm text-gray-600 text-center">
            Don't have an account?{" "}
            <span
              onClick={goToRegister}
              className="text-[#3A7138] font-semibold cursor-pointer hover:underline"
            >
              Register account
            </span>
          </div> */}
        </div>

        {/* Right Section */}
        <div className="hidden lg:flex items-center justify-center bg-gradient-to-br from-[#e6f2e6] to-[#cfe3cf]">
          <img
            className="w-[580px] h-[550px] object-cover "
            src={img}
            alt="lgn-img"
          />
        </div>
      </div>
    </div>
  );
};

export default Login;
